// Supported currency symbols
const YEN_SYMBOL = '¥';
const DOLLAR_SYMBOL = '$';

export type CurrencySymbols = typeof YEN_SYMBOL | typeof DOLLAR_SYMBOL;

// Supported currency codes
export const YEN_CURRENCY_CODE = 'jpy';
export const DOLLAR_CURRENCY_CODE = 'usd';
type CurrencyCodes = typeof YEN_CURRENCY_CODE | typeof DOLLAR_CURRENCY_CODE;

type SymbolsByCurrencyCode = {
  [key in CurrencyCodes]: CurrencySymbols;
};

export const symbolsByCurrencyCode: SymbolsByCurrencyCode = {
  usd: DOLLAR_SYMBOL,
  jpy: YEN_SYMBOL,
};

type Locales = 'en-us' | 'ja-jp';

type CurrencyCodesByLocale = {
  [key in Locales]: CurrencyCodes;
};

export const currencyCodesByLocale: CurrencyCodesByLocale = {
  'en-us': DOLLAR_CURRENCY_CODE,
  'ja-jp': YEN_CURRENCY_CODE,
};

export const getCurrencyCode = (locale: string) => {
  const currencyCode = currencyCodesByLocale[locale.toLowerCase() as Locales];

  if (!currencyCode) {
    throw new Error('Unsupported locale or currency code');
  }

  return currencyCode;
};

/**
 * Gets currency symbol by locale or currency code
 */
export const getCurrencySymbol = (currencyCode: string) => {
  const currencySymbol = symbolsByCurrencyCode[currencyCode?.toLowerCase() as CurrencyCodes];

  if (!currencySymbol) {
    throw new Error('Unsupported locale or currency code');
  }

  return currencySymbol;
};
